












































































import { Component, Vue } from 'vue-property-decorator';
import { ActionSheet } from 'vant';
import RegisterForm from '@/components/RegisterForm.vue';
import LogoUnion from '@/components/merchant/LogoUnion.vue';
import merchantApi from '@/api/merchant';
import { ServerResponse } from '@/interface/common';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'MerchantHome',
  components: {
    [ActionSheet.name]: ActionSheet,
    RegisterForm,
    LogoUnion
  },
  filters: {
    // eslint-disable-next-line
    showPrice(item: any) {
      if (item.saleType === 'SELL') {
        return `${ item.sellPrice }/元`;
      } else {
        return `${ item.dailyRental }/天起`;
      }
    }
  }
})

export default class MerchantHome extends Vue {
  invitationCode = '';
  productList = [];
  showRegisterBox = false;

  created() {
    document.title = '首页';
    this.getActiveProduct();
    this.invitationCode = getUrlParam('invitationCode');
  }

  // 获取商品数据
  getActiveProduct() {
    this.$http({
      url: `${ merchantApi.getActiveProduct.url }/1374610765763448832`,
      method: merchantApi.getActiveProduct.method
    }).then((res: ServerResponse) => {
      const data = res.data || {};

      this.productList = data.items ? data.items : [];
    });
  }

  // 展示注册弹窗
  goToRegister() {
    this.showRegisterBox = true;
  }
}
